import html2canvas from 'html2canvas';
import React, { useEffect, useRef, useState } from 'react'
import { Card } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import ocr from '../../service/api/recognition/ocr';
import OcrResponseModal from '../../jsx/components/resultModal/resultModal';
import PrimaryButton from '../../jsx/components/button/primaryButton';

export default function OcrDemo() {
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const dispatch = useDispatch()
  const [isLoadingActive,setIsLoadingActive] = useState(false)
  const[image,setImage] = useState(null)
  const[ocrResultModal,setOcrResultModal] = useState(false)
  const[ocrOutput,setOcrOutput] = useState({})
  useEffect (() => {
    // Access the camera
    navigator.mediaDevices.getUserMedia({  video: {
      width: { ideal: 1920 },
      height: { ideal: 1080 }
    } })
      .then((mediaStream) => {
        streamRef.current = mediaStream;
        if (videoRef.current) {
          videoRef.current.srcObject = mediaStream;
        }
      })
      .catch((error) => {
        console.error('Error accessing the camera:', error);
      });

    return () => {
      // debugger
      if (streamRef.current) {
        const tracks = streamRef.current.getTracks();
        tracks.forEach(track => {
          track.stop();
        });
      }
    };
  }, []);
  const handleScreenShot = () => {
    setIsLoadingActive(true);
    const video = document.getElementById("ocrFrame");
    if (!video) return;
    video.pause();

 

    html2canvas(document.getElementById("ocrFrame"))
      .then((canvas) => {
        canvas.style.display = "none";
        document.body.appendChild(canvas);
        return canvas;
      })
      .then((canvas) => {
        const image = canvas
          .toDataURL("image/png")
          .replace("data:", "")
          .replace(/^.+,/, "");

        const byteCharacters = atob(image);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray]);

        setImage(blob);

        let formData = new FormData();

        formData.append("image", blob, "screenshot.png");

        dispatch(
          ocr(
            formData,
            (res) => {
              const video = document.getElementById("ocrFrame");
              if (!video) return;
              video.play();
              setOcrResultModal(true);
             
           
              setOcrOutput(res.data);

              setIsLoadingActive(false);
            },
            (err) => {
              const video = document.getElementById("ocrFrame");
              if (!video) return;
              video.play();
              setIsLoadingActive(false);
            }
          )
        );
      });
  };
  return (
<>
    <div
        className="row d-flex justify-content-center align-items-center"
        style={{ height: "" }}
      >
        <Card className="bg-white" style={{ width: "98%" }}>
          <Card.Header className="d-block">
            {/* <Card.Title style={{ fontWeight: '700' }}>Start OCR</Card.Title> */}
            <PrimaryButton buttonName={"Start OCR"} style={{width:'150px'}} onClick={handleScreenShot} isLoading={isLoadingActive} loadingMessage={"Detecting"}/>
     
          </Card.Header>
       
            <Card.Body className="card-body-video p-1" >
             
           

            
              <video
              ref={videoRef}
                id="ocrFrame"
                playsInline
                autoPlay={true}
                style={{ objectFit: "cover", border: "2px solid #ff7a35",width:'100%' ,height: 'calc(100vh - 160px)'}}
                muted={true}></video>
            </Card.Body>
          
         

          
        </Card>

        {ocrResultModal && (
        <>
          <OcrResponseModal
            text={ocrOutput}
            onClickReject={() => {
              const video = document.getElementById("ocrFrame");
              if (!video) return;
              video.play();
              setOcrResultModal(false);
             
            }}
            onClickAccept={() => {
              const video = document.getElementById("ocrFrame");
              if (!video) return;
              video.play();
             
              setOcrResultModal(false);
            }}
            modalStatus={true}
            yesBtnTxt={"Thanks"}
            noBtnTxt={"Cancel"}
            loadingButtonName={"Saving"}
            loaderActive={isLoadingActive}
          />
        </>
      )}
      </div>
   </>
  )
}
